import Render from "@Views/root/user/stripe-subscription.html";
import {Component, Vue} from "vue-property-decorator";
import {IStripePaymentMethod, IStripeSubscription} from "@Store/types/user";
import {user} from "@Store/modules/user";
import {StripeSubscriptionType} from "@Enums/stripe-subscription-type";
import {IPopinAction,IPopin} from '@Store/types'
import {INotification} from "@Store/types/notification";
import {notif} from "@Store/modules/notification";
import {popIn} from "@Store/modules/popin";
import {purchase} from "@Store/modules/purchase";


@Render
@Component({})
export class StripeSubscription extends Vue {

	async mounted() {
		this.$emit('navigate', 'user-stripe-subscription')
		await user.reloadUser()
	}

	get stripeSubscription(): IStripeSubscription {
		return user.user.stripeSubscription
	}

	get isSubscriptionYear(): boolean {
		return user.user.stripeSubscription.value == StripeSubscriptionType.year;
	}

	get isSubscriptionMonth(): boolean {
		return user.user.stripeSubscription.value == StripeSubscriptionType.month;
	}

	get isSubscriptionCanceled(): boolean {
		return user.user.stripeSubscriptionCanceled.is_canceled;
    }

	get canceledInitDate(): string {

		const subscriptionDateObj = new Date(user.user.stripeSubscriptionCanceled.canceled_init_date)

		const formatter = new Intl.DateTimeFormat('fr-FR', {
			day: '2-digit',
			month: 'long',
			year: 'numeric'
		})

		return formatter.format(subscriptionDateObj);
	}


	get subscriptionTitle(): string {
		const pm = this.stripeSubscription

		if(!pm) return ''

		if (this.isSubscriptionYear) {
			return this.$i18n.t('vm.root.user.stripe-subscription.annual-subscription').toString();
		}
		if (this.isSubscriptionMonth) {
			return this.$i18n.t('vm.root.user.stripe-subscription.monthly-subscription').toString();
		}
		return ''

	}

	get subscriptionExpirationText() {
		if (!this.stripeSubscription) return ''

		const subscriptionDateObj = new Date(this.stripeSubscription.session_date)

		const formatter = new Intl.DateTimeFormat('fr-FR', {
			day: '2-digit',
			month: 'long',
			year: 'numeric'
		})
		const formattedDate = formatter.format(subscriptionDateObj)

		const now = new Date()
		if (subscriptionDateObj < now) {
			return this.$i18n.t('vm.root.user.stripe-subscription.license-expired-on',[formattedDate]).toString();
		}

		return this.$i18n.t('vm.root.user.stripe-subscription.license-valid-until',[formattedDate]).toString();
	}

	get isExpired(): boolean {
		if (!this.stripeSubscription) return true

		const expirationDate = new Date(this.stripeSubscription.session_date)
		const now = new Date()

		return expirationDate < now
	}

	get isDemo(): boolean {
		return !!location.hostname && location.hostname.startsWith('demo')
	}

	get canShowSubscriptionInfos(): boolean {
		return !!this.stripeSubscription
	}




	 cancelSubscription(): void {

		const action: IPopinAction = {
			label: this.$i18n.t('vm.root.user.stripe-subscription.popin.action.label').toString(),
			title: this.$i18n.t('vm.root.user.stripe-subscription.popin.action.title').toString(),
			condition: ({ choice, otherReason }: { choice: string; otherReason: string }) => {
				if (!choice) return false;
				if (choice === 'other') return otherReason.trim().length > 0;
				return true;
			},
			callback: async ({ choice, otherReason }: { choice: string; otherReason: string },updateLoading: (loading: boolean) => void) => {
				try {
					updateLoading(true)
					await purchase.cancelStripeSubscription(choice === 'other' ? otherReason : choice)

					let notification: INotification = {message: this.$i18n.t('vm.root.user.stripe-subscription.cancel-subscription.success').toString(), actions:[], delay: 5000, canClose: true}
					notif.success(notification)

				} catch (err) {
					let notification: INotification = {message: this.$i18n.t('vm.root.user.stripe-subscription.cancel-subscription.failed').toString(), actions:[], delay: 5000, canClose: true}
					notif.error(notification)
				} finally {
					await user.reloadUser()
					updateLoading(false)
				}
			},

			stayOpen: false
		};

		const cancelPopin: IPopin = {
			title: this.$i18n.t('vm.root.user.stripe-subscription.popin.title').toString(),
			content: { component: 'popin-cancel-subscription' },
			action,
			isWide: true,
			options: {
				choice: '',
				otherReason: ''
			},
			cancelAction: this.noChoiceAction,
			cancelLabel: this.$i18n.t('vm.root.user.stripe-subscription.popin.cancel.label').toString(),

		};
		popIn.error(cancelPopin);
	}


	private noChoiceAction(): void {
		this.$emit('close')
	}

}
